
'use strict';

var React = require('react');
var PropTypes = require('prop-types');

module.exports = function render(props) {
    var innerHtml = '<path d="M0 0h9L4.5 5z"/><!-- Filename: sourceSvg/action/dropdown.svg -->';
    var svgProps = {
        className: props.className ? (props.className + ' uig-svg-icon') : 'uig-svg-icon',
        dangerouslySetInnerHTML: {__html: innerHtml },
        viewBox: '0 0 9 5'
    }
    return React.createElement('svg', Object.assign({}, props, svgProps));
}
    